import {
  actionTypes,
  reportsRequestSuccess,
  reportsRequestFailure,
  reportGenerateSuccess,
  reportGenerateFailure,
  reportCampaignNameRequestSuccess,
  reportCampaignNameRequestFailure,
} from "./actions";

import {
  fetchReportsRequest,
  fetchReportGeneration,
  fetchCampaignNames,
} from "./services";

import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";

const fetchReportGenerationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.REPORT_GENERATE),
    mergeMap((action: { payload: any }) =>
      fetchReportGeneration(action.payload).pipe(
        map((response: any) => reportGenerateSuccess()),
        catchError((error: any) => of(reportGenerateFailure()))
      )
    )
  );

const fetchReportsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.REPORTS_REQUEST),
    mergeMap(() =>
      fetchReportsRequest().pipe(
        map((response: any) => reportsRequestSuccess(response)),
        catchError((error: any) => of(reportsRequestFailure(error)))
      )
    )
  );

const fetchCampaignNamesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.REPORTS_CAMPAIGNS_NAMES_REQUEST),
    mergeMap(() =>
      fetchCampaignNames().pipe(
        map((response: any) => reportCampaignNameRequestSuccess(response)),
        catchError((error: any) => of(reportCampaignNameRequestFailure(error)))
      )
    )
  );

export default [
  fetchReportGenerationEpic,
  fetchReportsRequestEpic,
  fetchCampaignNamesEpic,
];
